import * as axios from 'axios';

// Vem do ambiente no build (Bitbucket Deployments → REACT_APP_API).
// Sem a variável, cai no localhost do ambiente de desenvolvimento.
export const baseURL = process.env.REACT_APP_API || 'http://localhost:80/api/'

var api = axios.create({
    baseURL: baseURL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else if (config.headers) {
        delete config.headers.Authorization;
    }
    return config;
});



// api.interceptors.response.use(function (response) {
//     if(response.status == 401) {
//         return <Redirect
//             push 
//             to={{
//                 pathname: "/login"
//              }}
//         />
//     }
//     return response;
//   }, function (error) {
//     if (error.response) {
//         console.log(error.response)
//         if(error.response.status == 401) {
//             toast.error("Não Autorizado");
//             return <Redirect
//             to={{
//                 pathname: "/",
//             }}
//             />
//         }
//     }
//     return Promise.reject(error);
// });

export default api;